const API_URL = import.meta.env.VITE_API_URL || 'https://sonarges-meeting-api.electrorimoo.workers.dev';

async function fetchAPI(endpoint, options = {}) {
  const res = await fetch(`${API_URL}${endpoint}`, {
    ...options,
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

  if (!res.ok) {
    const error = await res.json().catch(() => ({ error: 'Request failed' }));
    throw new Error(error.error || 'Request failed');
  }

  return res.json();
}

export const api = {
  auth: {
    login: (email, password) =>
      fetchAPI('/api/auth/login', {
        method: 'POST',
        body: JSON.stringify({ email, password }),
      }),
    register: (email, password, name) =>
      fetchAPI('/api/auth/register', {
        method: 'POST',
        body: JSON.stringify({ email, password, name }),
      }),
    logout: () =>
      fetchAPI('/api/auth/logout', {
        method: 'POST',
      }),
    me: () => fetchAPI('/api/auth/me'),
  },
  instances: {
    list: () => fetchAPI('/api/instances'),
    create: (data) =>
      fetchAPI('/api/instances', {
        method: 'POST',
        body: JSON.stringify(data),
      }),
    get: (id) => fetchAPI(`/api/instances/${id}`),
    addMember: (id, data) =>
      fetchAPI(`/api/instances/${id}/members`, {
        method: 'POST',
        body: JSON.stringify(data),
      }),
  },
  meetings: {
    list: (instanceId) => fetchAPI(`/api/meetings?instance_id=${instanceId}`),
    create: (data) =>
      fetchAPI('/api/meetings', {
        method: 'POST',
        body: JSON.stringify(data),
      }),
    get: (id) => fetchAPI(`/api/meetings/${id}`),
    addAgendaItem: (id, data) =>
      fetchAPI(`/api/meetings/${id}/agenda-items`, {
        method: 'POST',
        body: JSON.stringify(data),
      }),
    addParticipant: (id, data) =>
      fetchAPI(`/api/meetings/${id}/participants`, {
        method: 'POST',
        body: JSON.stringify(data),
      }),
    addActionItem: (id, data) =>
      fetchAPI(`/api/meetings/${id}/action-items`, {
        method: 'POST',
        body: JSON.stringify(data),
      }),
  },
  users: {
    list: (search = '', role = '') => fetchAPI(`/api/users?search=${search}&role=${role}`),
    updateRole: (id, global_role) =>
      fetchAPI(`/api/users/${id}/role`, {
        method: 'PATCH',
        body: JSON.stringify({ global_role }),
      }),
  },
};
